export const SocialLinks = {
  Discord: 'https://discord.gg/fDegqNPdyy',
  Twitter: 'https://twitter.com/BillionBatsClub'
};
